import * as Sentry from "@sentry/react";

export function initSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,

    // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^https:\/\/api\.intelligence\.briter\.co/],

    // Capture Replay for 10% of all sessions,
    // plus 100% of sessions with an error
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    environment: import.meta.env.VITE_ENV,

    enabled:
      import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED === "true",

    // Filter out potential sensitive data
    beforeSend(event) {
      // Don't send events from local development unless explicitly enabled
      if (
        !import.meta.env.VITE_ENV &&
        import.meta.env.VITE_SENTRY_ENABLED !== "true"
      ) {
        return null;
      }
      return event;
    },
  });
}
